export function handleInput(e, kind, data, setData){
    //Deal with Input Text
    if(e.target){
        switch(e.target.name) {
            case "name":
                setData( data = { ...data,
                    name: e.target.value
                })
                return null
            case "link":
                setData( data = { ...data,
                    link: e.target.value
                })
                return null
            default:
                break;
        }
    }else{
        if(kind === "branch"){
            setData( data = { ...data,
                branch: e
            });
            return null
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/general/roomFormWrapper/handleInput.js